import React from 'react'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'

const query = gql`
  query alarmTypes {
    alertTypes {
      id
      key
      acknowledge
      criticality
      priority
      i18n @client
      color @client
      icon @client
    }
  }
`

/**
 * Hook providing the alarm types from server mixed with local resolvers
 */
export default function useAlarmTypes() {
  const { data: { alertTypes = [] } = {} } = useQuery(query)
  return React.useMemo(() => alertTypes.reduce((res, cur) => ({ ...res, [cur.key]: cur }), {}), [alertTypes])
}
